/* OAY proof loop: on stain-repellent product cards, the photo flips between the
   model shot and the proof shot, with a line of text on each. Products come from
   the collection set in the OAY Sale section; photos and text per product type. */
(function () {
  var cfgEl = document.getElementById('oay-proof-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var products = cfg.products || {};
  var handles = Object.keys(products);
  if (!handles.length) return;

  var speed = parseFloat(cfg.speed) || 1.5;
  document.documentElement.style.setProperty('--oay-proof-cycle', (speed * 2) + 's');

  var rules = {};
  (cfg.rules || []).forEach(function (line) {
    var b = String(line).split('|').map(function (x) { return x.trim(); });
    if (b.length < 5 || !b[0]) return;
    rules[b[0].toLowerCase()] = { a: parseInt(b[1], 10) || 1, b: parseInt(b[2], 10) || 2, ta: b[3], tb: b[4], icon: (b[5] || '').toLowerCase() };
  });

  var DROP = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5s6 6.4 6 10.8a6 6 0 0 1-12 0c0-4.4 6-10.8 6-10.8z"/><path d="M9.5 15.2a2.6 2.6 0 0 0 2.5 2.3"/></svg>';
  var FEATHER = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.2 3.8a6 6 0 0 0-8.5 0L5 10.5V19h8.5l6.7-6.7a6 6 0 0 0 0-8.5z"/><path d="M16 8L2 22"/><path d="M17.5 15H9"/></svg>';
  var ICONS = { drop: DROP, feather: FEATHER };
  var cache = {};

  function sized(src) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
  }
  function getImages(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { return p && p.images ? p.images : []; })
        .catch(function () { return []; });
    }
    return cache[handle];
  }
  function esc(t) {
    var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML;
  }
  function frame(src, text, cls, icon) {
    return '<span class="oay-proof__f ' + cls + '"><img src="' + esc(sized(src)) + '" alt="" loading="lazy" decoding="async">' +
      (text ? '<span class="oay-proof__cap">' + (ICONS[icon] || DROP) + '<span>' + esc(text) + '</span></span>' : '') + '</span>';
  }

  function handleOf(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : null;
  }

  function decorate(a) {
    if (a.__oayProof) return;
    var h = handleOf(a);
    if (!h || !products.hasOwnProperty(h)) return;
    var img = a.querySelector('img');
    if (!img) return;
    a.__oayProof = true;
    var rule = rules[String(products[h] || '').toLowerCase()] || { a: 1, b: 2, ta: 'Stain repellent', tb: 'Spills slide off.' };
    getImages(h).then(function (imgs) {
      var ia = imgs[rule.a - 1], ib = imgs[rule.b - 1];
      if (!ia || !ib) return;
      if (getComputedStyle(a).position === 'static') a.style.position = 'relative';
      var box = document.createElement('span');
      box.className = 'oay-proof';
      box.setAttribute('aria-hidden', 'true');
      box.innerHTML = frame(ia, rule.ta, 'oay-proof__f--a', rule.icon) + frame(ib, rule.tb, 'oay-proof__f--b', rule.icon);
      a.appendChild(box);
      a.setAttribute('aria-label', (img.getAttribute('alt') || '') + ' — ' + rule.ta);
      // let shoppers still swipe through the card's own photos
      var stop = function () { box.classList.add('is-off'); };
      a.addEventListener('touchmove', stop, { passive: true, once: true });
      a.addEventListener('mouseenter', stop, { once: true });
    });
  }

  function scan(root) {
    var sel = handles.map(function (h) { return 'a[href*="/products/' + h + '"]'; }).join(',');
    (root.querySelectorAll ? root : document).querySelectorAll(sel).forEach(decorate);
  }

  function start() {
    scan(document);
    // throttle, not debounce: the sale timers change the page every second,
    // so a debounce could keep getting pushed back and never run
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scan(document); }, 300);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scan(document); }, 400);
    }, { passive: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
